import { render, staticRenderFns } from "./DarkCard.vue?vue&type=template&id=935273e2&scoped=true"
import script from "./DarkCard.vue?vue&type=script&lang=js"
export * from "./DarkCard.vue?vue&type=script&lang=js"
import style0 from "./DarkCard.vue?vue&type=style&index=0&id=935273e2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935273e2",
  null
  
)

export default component.exports